export const cn = (...args) =>
  args
    .flatMap((arg) => {
      // If the argument is a string, include it directly
      if (typeof arg === "string") return arg;

      // If the argument is an array, recursively call cx to handle elements inside the array
      if (Array.isArray(arg)) return cn(...arg);

      // If the argument is an object, check for true/false values for each key
      if (typeof arg === "object" && arg !== null) {
        return Object.entries(arg)
          .filter(([, value]) => value)
          .map(([key]) => key);
      }
      // Ignore invalid arguments
      return [];
    })
    .join(" "); // Join the valid classes with spaces
